import { createContext, useContext } from 'react'

export type VisibilityConditions = {
    [k: string]: boolean
}

type VisibilityContextInterface = {
    isReady: () => boolean
    updateCondition: (
        condition: keyof VisibilityConditions,
        value: boolean,
    ) => void
}

export const VisibilityContext = createContext<
    VisibilityContextInterface | undefined
>(undefined)

export const useVisibilityContext = () => useContext(VisibilityContext)
